export function jsx( tagName: string, attributes: { [ key: string ]: any } = {}, ...children: Array<HTMLElement | string> ): HTMLElement {

	if ( !tagName || typeof tagName !== 'string' ) {
		throw new Error( 'Invalid tag name' );
	}

	let element = document.createElement( tagName );

	for ( let attribute_key of Object.keys( attributes ) ) {
		let attribute_value = attributes[ attribute_key ];
		element.setAttribute( attribute_key, attribute_value );
	}

	for ( let child of children ) {
		if ( child instanceof HTMLElement ) {
			element.appendChild( child );
		} else if ( typeof child === 'string' ) {
			element.appendChild( document.createTextNode( child ) );
		}
	}

	return element;
}
